import React from 'react'

import {generatePDF} from '@/utils/html-to-pdf'

import type {Service} from '@/utils/html-to-pdf'

interface Props {
    service: Service
    state: any
    errorMessage?: string
}

const useGeneratePdf = ({service, state, errorMessage}: Props) => {
    const [loading, setLoading] = React.useState<boolean>(false)
    const [error, setError] = React.useState<string>('')
    const [pdfLink, setPdfLink] = React.useState<string>('')

    const handleGeneratePdf = async () => {
        try {
            setLoading(true)

            const sharableLinkResponse = await generatePDF(service, state)

            setPdfLink(sharableLinkResponse)

            return sharableLinkResponse
        } catch (error) {
            errorMessage && setError(errorMessage)

            throw new Error(errorMessage)
        } finally {
            setLoading(false)
        }
    }

    return {handleGeneratePdf, pdfLink, loading, error}
}

export default useGeneratePdf
